import React, { useState, useEffect } from 'react';

const Vision = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // === Styles ===
  const sectionStyle = {
    padding: isMobile ? '20px 10px' : '40px 0',
    margin: '0 auto',
    backgroundColor: '#fff',
  };

  const containerStyle = {
    maxWidth: isMobile ? '100%' : '1200px',
    margin: '0 auto',
    padding: '0 15px',
  };

  const rowStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'center',
    gap: '20px',
  };

  const colStyle = {
    flex: '1',
    minWidth: isMobile ? '100%' : '300px',
    marginBottom: isMobile ? '20px' : '0',
  };

  const headingStyle = {
    textAlign: 'center',
    paddingBottom: '30px',
    fontSize: isMobile ? '24px' : '32px',
    color: '#002E5B', // Updated to a more professional navy tone
    fontWeight: '700',
  };

  const cardStyle = {
    backgroundColor: '#002E5B',
    padding: '25px 20px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    color: 'white',
    textAlign: 'center',
    minHeight: '250px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };

  const cardHeadingStyle = {
    marginBottom: '15px',
    fontSize: '22px',
    fontWeight: '600',
  };

  const cardTextStyle = {
    fontSize: '16px',
    lineHeight: '1.5',
  };

  // === JSX ===
  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <h3 style={headingStyle}>About Our Vision & Mission</h3>
        <div style={rowStyle}>
          <article style={colStyle}>
            <div style={cardStyle}>
              <h4 style={cardHeadingStyle}>Vision</h4>
              <p style={cardTextStyle} className='text-white'>
                At Platinum24 Cabs, our vision is to be the leading name in luxury and reliable transportation,
                setting new standards for convenience, safety, and customer satisfaction — 24 hours a day, 7 days a week.
              </p>
            </div>
          </article>

          <article style={colStyle}>
            <div style={cardStyle}>
              <h4 style={cardHeadingStyle}>Mission</h4>
              <p style={cardTextStyle} className='text-white'>
                Our mission is to provide seamless, safe, and professional cab services that our customers can rely on
                — any time, anywhere. We are committed to maintaining a premium fleet, top-notch drivers,
                and the highest service standards in the industry.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Vision;
